import { createAction } from '@mews/framework';
import { prefix } from '../module';
import { AttributeType, BasePrice, CapacityOffsetAdjustments, RateAdjustment, AttributePrice } from '../types';

export const PRICING_DATA_UPDATED = prefix('PRICING_DATA_UPDATED');

export const PRODUCT_ID_SELECTED = prefix('PRODUCT_ID_SELECTED');
export const RATE_ID_SELECTED = prefix('RATE_ID_SELECTED');
export const SERVICE_ID_SELECTED = prefix('SERVICE_ID_SELECTED');

export const updatePricingData = (updatedPricingData: {
    attributeType: AttributeType;
    basePrice: BasePrice;
    capacityOffsetAdjustments: CapacityOffsetAdjustments;
    attributePrices: Array<AttributePrice>;
    rateAdjustment: RateAdjustment;
}) => createAction(PRICING_DATA_UPDATED, updatedPricingData);

export const selectProductId = (productId: string) => createAction(PRODUCT_ID_SELECTED, { productId });
export const selectRateId = (rateId: string) => createAction(RATE_ID_SELECTED, { rateId });
export const selectServiceId = (serviceId: string) => createAction(SERVICE_ID_SELECTED, { serviceId });
